/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Title_2Inputs */

const en_home_hero_title_2 = /** @type {(inputs: Home_Hero_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`real work for your business.`)
};

const lv_home_hero_title_2 = /** @type {(inputs: Home_Hero_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`īstu darbu Jūsu uzņēmumā.`)
};

/**
* | output |
* | --- |
* | "real work for your business." |
*
* @param {Home_Hero_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_hero_title_2 = /** @type {((inputs?: Home_Hero_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_hero_title_2(inputs)
	return en_home_hero_title_2(inputs)
});